module.exports = __webpack_public_path__ + "img/home-page-mobile-bg-image.0e2bd4da.svg";